module.exports = __webpack_public_path__ + "static/media/passport.8d90a3c0.png";